// V10.6 — Industry SEO Pages Registry
// Single source of truth for all 15+ industry landing pages.
// Each entry generates a unique SEO-optimized page at /<slug>.
//
// Per user request V10.6 final: SEO-first to capture global organic traffic
// from aviation, spaceflight, electric, fotovoltaice, telecom, HVAC, etc.

export const INDUSTRY_PAGES = [
  {
    slug: 'investitori',
    title_ro: 'Investitori — Energy Project Design',
    title_en: 'Investors — Energy Project Design',
    h1: 'Construim cea mai influentă platformă globală multi-industrie',
    icon: '💎',
    accent: 'amber',
    eyebrow: 'Strategic capital opportunity',
    intro: 'Astăzi platforma nr.1 în România pentru documentație gaze naturale certificată eIDAS QES. Mâine — platforma globală multi-industrie pentru construcții, energie, transport, aviație, spațial.',
    metrics: [
      { v: '$1.4T', l: 'TAM global' }, { v: '€8B', l: 'Piață țintă RO' },
      { v: '22+',   l: 'Servicii planificate' }, { v: '$999K/lună', l: 'Plan Developer Elite' },
    ],
    keywords: 'investitori energy project design, B2B SaaS Romania investment, gas platform Series A, technical documentation startup, eIDAS QES platform, NewSpace investing, climate tech Romania, AI documentation seed, $999999 developer plan',
    cta_email: 'invest@energyprojectdesign.com',
    cta_label: 'Trimite tichet investiție',
    bullets: [
      'Cerere validată — operatorii de distribuție gaze cer documentație 100% digitală',
      'Avantaj reglementar — eIDAS + NTPEE 2018 + ANRE 89/2018 integrate nativ',
      'Tehnologie defensibilă — 554 SAP materials + 221 fields + 33 templates',
      'Stack production-grade — React + FastAPI + MongoDB + Stripe LIVE + AI',
      'Expansiune naturală — același engine se aplică la 22+ industrii',
    ],
  },
  {
    slug: 'aviatie',
    title_ro: 'Aviație civilă — Documentație tehnică EPD',
    title_en: 'Civil aviation — EPD technical documentation',
    h1: 'Documentație tehnică digitală pentru aviația civilă',
    icon: '✈️',
    accent: 'blue',
    eyebrow: 'Airflight & Civil Aviation',
    intro: 'Platforma EPD oferă documentație tehnică certificată pentru operatori aerieni, MRO (Maintenance Repair Overhaul), ground handling, drone commercial, aerodromuri și aviație generală — conform EASA + ICAO + AeroSpaceMD.',
    metrics: [
      { v: 'EASA', l: 'Conformitate' }, { v: 'ICAO', l: 'Standarde' },
      { v: '24/7', l: 'Disponibilitate' }, { v: '100%', l: 'Digital QES' },
    ],
    keywords: 'aviatie romania, civil aviation documentation, EASA Part 145, MRO documentation, ground handling certification, drone commercial license, UAV operator documentation, charter operations, ULM, aerodrom certification, AeroSpaceMD, airflight technical docs',
    cta_email: 'aviation@energyprojectdesign.com',
    cta_label: 'Solicită demo aviație',
    bullets: [
      'Manual operator (EASA Part-OPS) digital QES',
      'Programe MRO & Camo Part-145 certificate',
      'Documentație ground handling + GOM',
      'Operațiuni drone commerciale & SORA risk assessment',
      'Manuale aerodrom + ATCO documentation',
    ],
  },
  {
    slug: 'airflight',
    title_ro: 'Airflight — Commercial flights documentation',
    title_en: 'Airflight — Commercial flights documentation',
    h1: 'Airflight documentation platform — global commercial aviation',
    icon: '🛫',
    accent: 'blue',
    eyebrow: 'Global commercial flight operations',
    intro: 'EPD streamlines airline ops documentation: AOC (Air Operator Certificate), training records, fleet management, scheduling, IATA Operational Safety Audit (IOSA) prep — entirely digital and QES-certified.',
    metrics: [
      { v: 'AOC', l: 'Certificates' }, { v: 'IOSA', l: 'Audit-ready' },
      { v: 'IATA', l: 'Compliant' }, { v: 'eIDAS', l: 'Signature' },
    ],
    keywords: 'airflight documentation, AOC certificate platform, IOSA audit prep, IATA compliance, airline operations software, fleet management documentation, flight ops manual digital, commercial pilot license documentation, EASA Part-MED',
    cta_email: 'airflight@energyprojectdesign.com',
    cta_label: 'Request airflight demo',
    bullets: [
      'AOC application & continuous compliance',
      'IOSA audit preparation toolkit',
      'Crew training records management',
      'Fleet airworthiness directives tracking',
      'Multilingual SOPs & operational manuals',
    ],
  },
  {
    slug: 'spatial',
    title_ro: 'Spațial · NewSpace — Documentație EPD',
    title_en: 'Space industry · NewSpace — EPD documentation',
    h1: 'Documentație pentru industria spațială & NewSpace',
    icon: '🛰️',
    accent: 'indigo',
    eyebrow: 'NewSpace & Orbital missions',
    intro: 'De la satelite CubeSat la lansatoare orbital, EPD oferă documentație ITAR-compliant, FAA Part-450 launch authorization, ESA project management — toate digital, semnate eIDAS, cu traceability completă.',
    metrics: [
      { v: 'FAA', l: 'Part-450' }, { v: 'ESA', l: 'Standards' },
      { v: 'ITAR', l: 'Aware' }, { v: 'CubeSat', l: 'Ready' },
    ],
    keywords: 'spatial romania, NewSpace documentation, CubeSat platform, satellite operator license, FAA Part-450 launch, ESA contractor documentation, ITAR compliance, orbital debris mitigation, ROMSPACE, Romanian Space Agency, space launch documentation',
    cta_email: 'space@energyprojectdesign.com',
    cta_label: 'Cerere consultanță spațială',
    bullets: [
      'FAA Part-450 launch authorization',
      'Satellite frequency coordination (ITU)',
      'CubeSat mission documentation',
      'ESA contractor compliance package',
      'Orbital debris mitigation plans',
    ],
  },
  {
    slug: 'spaceflight',
    title_ro: 'Spaceflight — Mission documentation platform',
    title_en: 'Spaceflight — Mission documentation platform',
    h1: 'Spaceflight mission documentation — end-to-end',
    icon: '🚀',
    accent: 'indigo',
    eyebrow: 'Orbital & sub-orbital missions',
    intro: 'EPD unifies pre-flight reviews, launch readiness, mission control logs, payload documentation, range safety analysis and post-flight reports in one platform — multilingual, audit-ready, QES-signed.',
    metrics: [
      { v: 'PFR', l: 'Pre-Flight' }, { v: 'LRR', l: 'Readiness' },
      { v: 'MCC', l: 'Control logs' }, { v: 'PMR', l: 'Post-mission' },
    ],
    keywords: 'spaceflight documentation, launch readiness review, mission control logs platform, payload documentation, range safety analysis, post-flight report, suborbital flight ops, orbital mission, Romanian space industry',
    cta_email: 'spaceflight@energyprojectdesign.com',
    cta_label: 'Schedule spaceflight onboarding',
    bullets: [
      'Pre-flight review (PFR) workflow',
      'Launch readiness review (LRR) checklist',
      'Mission control log book digital',
      'Range safety analysis templates',
      'Post-mission report (PMR) automation',
    ],
  },
  {
    slug: 'satelite',
    title_ro: 'Satelite — Operator documentation',
    title_en: 'Satellites — Operator documentation',
    h1: 'Documentație operator satelit — global, multi-lingvă',
    icon: '📡',
    accent: 'indigo',
    eyebrow: 'Satellite operations',
    intro: 'EPD pentru operatori satelit comerciali, GEO/MEO/LEO, downlink stations, TT&C ground segment — documentație ITU + FCC + EASA aligned, semnată QES, indexată multilingual.',
    metrics: [
      { v: 'ITU', l: 'Frequency' }, { v: 'FCC', l: 'License' },
      { v: 'GEO/MEO/LEO', l: 'Orbits' }, { v: 'TT&C', l: 'Ground' },
    ],
    keywords: 'satelite romania, satellite operator documentation, ITU filing, FCC satellite license, GEO LEO MEO operations, ground station documentation, TT&C, downlink, satellite constellation',
    cta_email: 'satellites@energyprojectdesign.com',
    cta_label: 'Solicită platforma sateliți',
    bullets: [
      'ITU frequency coordination filings',
      'FCC Earth Station license documentation',
      'GEO/MEO/LEO constellation planning',
      'Ground segment TT&C documentation',
      'Downlink scheduling & compliance',
    ],
  },
  {
    slug: 'drone-uav',
    title_ro: 'Drone & UAV — Documentație operator',
    title_en: 'Drones & UAV — Operator documentation',
    h1: 'Operator drone & UAV — totul certificat și digital',
    icon: '🛸',
    accent: 'cyan',
    eyebrow: 'Unmanned aerial systems',
    intro: 'EPD pentru operatori UAV: SORA risk assessment, autorizații AACR, declarații Open A1/A2/A3, certificate Specific operations, Standard scenarios STS — toate semnate eIDAS.',
    metrics: [
      { v: 'SORA', l: 'Risk' }, { v: 'AACR', l: 'Autoritate RO' },
      { v: 'A1/A2/A3', l: 'Categorii' }, { v: 'STS', l: 'Standard' },
    ],
    keywords: 'drone romania, UAV operator documentation, SORA risk assessment, AACR autorizatie drone, EASA U-space, drone commercial, BVLOS operations, Standard Scenarios STS-01 STS-02',
    cta_email: 'drone@energyprojectdesign.com',
    cta_label: 'Solicită licențiere UAV',
    bullets: [
      'SORA Methodology — risk assessment automated',
      'AACR authorization filing',
      'Standard Scenarios (STS-01/02) templates',
      'BVLOS operations documentation',
      'Multi-pilot training records',
    ],
  },
  {
    slug: 'electric',
    title_ro: 'Instalații electrice — Documentație EPD',
    title_en: 'Electrical installations — EPD documentation',
    h1: 'Instalații electrice — proiectare & autorizare ANRE',
    icon: '⚡',
    accent: 'amber',
    eyebrow: 'Electrical engineering',
    intro: 'Documentație instalații electrice JT/MT/IT, autorizații ANRE PDD/EDD, branșamente electrice, sisteme protecție, prize aer, EV charging stations — semnate eIDAS QES.',
    metrics: [
      { v: 'ANRE', l: 'PDD/EDD' }, { v: 'JT/MT/IT', l: 'Niveluri' },
      { v: '20 docs', l: 'Templates' }, { v: 'EV', l: 'Charging' },
    ],
    keywords: 'instalatii electrice, autorizatie ANRE PDD EDD, bransament electric, statie incarcare EV, proiectare electrica, ANRE PE, electricieni autorizati, schema unifilar, prize aer',
    cta_email: 'electric@energyprojectdesign.com',
    cta_label: 'Începe proiect electric',
    bullets: [
      'Branșamente electrice JT documentație ANRE',
      'Stații încărcare EV — DC/AC schemes',
      'Sisteme protecție prize aer (BS EN 62305)',
      'Audit energetic & DTAC + PTH',
      'Instalații industriale MT/IT',
    ],
  },
  {
    slug: 'fotovoltaice',
    title_ro: 'Sisteme fotovoltaice — Documentație EPD',
    title_en: 'Photovoltaic systems — EPD documentation',
    h1: 'Sisteme fotovoltaice — proiectare & racordare',
    icon: '☀️',
    accent: 'amber',
    eyebrow: 'Solar PV systems',
    intro: 'Proiecte fotovoltaice rezidențiale, comerciale, parc PV de zeci de MW — racordare ANRE, Casa Verde Fotovoltaice, schema unifilar, audit Distrgaz Sud, eIDAS QES.',
    metrics: [
      { v: 'Casa Verde', l: 'Eligibilitate' }, { v: 'ANRE', l: 'Racordare' },
      { v: 'On-grid', l: 'Type' }, { v: 'Hibrid', l: 'Battery' },
    ],
    keywords: 'fotovoltaice romania, panouri solare proiectare, Casa Verde Fotovoltaice, parc fotovoltaic, racordare ANRE, sistem PV rezidential, baterie stocare, on-grid hybrid, schema unifilara fotovoltaica',
    cta_email: 'pv@energyprojectdesign.com',
    cta_label: 'Începe proiect PV',
    bullets: [
      'Sisteme rezidențiale ≤27 kW (Casa Verde)',
      'Sisteme comerciale 27-200 kW',
      'Parcuri PV ≥1 MW racordare MT',
      'Sisteme hibrid cu baterii stocare',
      'Audit producție + ROI calculator',
    ],
  },
  {
    slug: 'telecom',
    title_ro: 'Telecomunicații — Documentație EPD',
    title_en: 'Telecommunications — EPD documentation',
    h1: 'Telecom — fibra optică, antene 5G, ducte',
    icon: '📶',
    accent: 'violet',
    eyebrow: 'Telecom infrastructure',
    intro: 'Documentație FTTH, FTTB, FTTC, 5G base stations, microwave links, ducte subterane, autorizații ANCOM + Netcity, semnate digital eIDAS.',
    metrics: [
      { v: 'FTTH', l: 'Last mile' }, { v: '5G', l: 'New radio' },
      { v: 'ANCOM', l: 'Autorizare' }, { v: 'Netcity', l: 'București' },
    ],
    keywords: 'telecom romania, FTTH FTTB FTTC fibra optica, 5G base station, autorizatie ANCOM, Netcity Telecom Bucuresti, microwave link, ducte subterane telecom, infrastructura 5G',
    cta_email: 'telecom@energyprojectdesign.com',
    cta_label: 'Solicită platforma telecom',
    bullets: [
      'Proiecte FTTH/FTTB/FTTC last-mile',
      '5G base station siting & permits',
      'Microwave link planning + line-of-sight',
      'Ducte subterane multi-operator',
      'Autorizații ANCOM + Netcity (București)',
    ],
  },
  {
    slug: 'hvac',
    title_ro: 'HVAC · Climatizare — Documentație EPD',
    title_en: 'HVAC · Air conditioning — EPD documentation',
    h1: 'HVAC — climatizare, ventilație, pompe căldură',
    icon: '🌬️',
    accent: 'cyan',
    eyebrow: 'Climate engineering',
    intro: 'Sisteme HVAC rezidențiale & industriale, pompe căldură geotermal, VRV/VRF, recuperare căldură, audit energetic, autorizații F-Gas, eIDAS QES.',
    metrics: [
      { v: 'F-Gas', l: 'Compliance' }, { v: 'VRV/VRF', l: 'Multi-split' },
      { v: 'Geo', l: 'Heat pumps' }, { v: 'A++', l: 'Eficiență' },
    ],
    keywords: 'HVAC romania, climatizare proiectare, pompa caldura geotermal, VRV VRF sistem, recuperare caldura, F-Gas autorizare, audit energetic cladiri, ventilatie industriala',
    cta_email: 'hvac@energyprojectdesign.com',
    cta_label: 'Solicită demo HVAC',
    bullets: [
      'Sisteme VRV/VRF multi-split',
      'Pompe căldură geotermal & aerotermal',
      'Recuperare căldură ERV / HRV',
      'F-Gas certification & leak detection',
      'Audit energetic + nZEB compliance',
    ],
  },
  {
    slug: 'apa-canal',
    title_ro: 'Apă-Canal — Documentație EPD',
    title_en: 'Water & Sewerage — EPD documentation',
    h1: 'Rețele apă potabilă, canalizare, stații tratare',
    icon: '💧',
    accent: 'blue',
    eyebrow: 'Water infrastructure',
    intro: 'Branșamente apă & canal, stații tratare, rețele transport, Apa Nova București, Compania de Apă Iași, ANB, autorizații DA Apele Române, semnate eIDAS.',
    metrics: [
      { v: 'ANRSC', l: 'Tarif' }, { v: 'Apa Nova', l: 'Operator BUC' },
      { v: 'DA', l: 'Apele Române' }, { v: 'GIS', l: 'Mapping' },
    ],
    keywords: 'apa canal romania, bransament apa potabila, statie tratare apa uzata, Apa Nova Bucuresti, ANRSC, DA Apele Romane, retea distributie apa, canalizare pluviala menajera',
    cta_email: 'apacanal@energyprojectdesign.com',
    cta_label: 'Solicită platforma apă-canal',
    bullets: [
      'Branșamente apă potabilă DN20-DN200',
      'Stații pompare & tratare',
      'Rețele canalizare gravitațională',
      'Sisteme separare pluvial-menajer',
      'Operare GIS multi-utilitate',
    ],
  },
  {
    slug: 'feroviar',
    title_ro: 'Feroviar — Documentație EPD',
    title_en: 'Railway — EPD documentation',
    h1: 'Infrastructură feroviară — sigure, digitale, QES',
    icon: '🚆',
    accent: 'indigo',
    eyebrow: 'Railway infrastructure',
    intro: 'Documentație CFR, AFER, ASFR, ERTMS, treceri la nivel, electrificare, semnalizare, autorizații conforme TSI (Technical Specifications for Interoperability) EU.',
    metrics: [
      { v: 'AFER', l: 'Autoritate' }, { v: 'ERTMS', l: 'Signaling' },
      { v: 'TSI', l: 'EU' }, { v: 'CFR', l: 'Operator' },
    ],
    keywords: 'feroviar romania, infrastructura CFR, AFER autorizare, ERTMS ETCS, treceri nivel feroviare, electrificare cale ferata, semnalizare automata bloc, TSI EU interoperabilitate',
    cta_email: 'rail@energyprojectdesign.com',
    cta_label: 'Solicită documentație feroviar',
    bullets: [
      'Modernizare cale ferată viteza ≥160 km/h',
      'Electrificare 25kV AC 50Hz',
      'ERTMS Level 2/3 deployment',
      'Treceri la nivel automatizate',
      'Stații pasageri ADA-compliant',
    ],
  },
  {
    slug: 'sanatate',
    title_ro: 'Sănătate — Construcție spitale & clinici',
    title_en: 'Healthcare — Hospital & clinic construction',
    h1: 'Sănătate · Spitale, clinici, laboratoare',
    icon: '🏥',
    accent: 'rose',
    eyebrow: 'Healthcare infrastructure',
    intro: 'Documentație tehnică pentru spitale, clinici, laboratoare biosafety BSL-2/3, săli operație, izolare TBC/COVID, gaze medicale, eIDAS QES, autorizații DSP.',
    metrics: [
      { v: 'DSP', l: 'Autorizare' }, { v: 'BSL-2/3', l: 'Biosafety' },
      { v: 'O2/N2O/CO2', l: 'Gaze' }, { v: 'HEPA', l: 'Filtre' },
    ],
    keywords: 'spitale romania, constructie spital, clinica privata, laborator biosafety BSL3, gaze medicale O2 N2O, sala operatie ISO 8, DSP autorizare sanitara, ATI infrastructure',
    cta_email: 'health@energyprojectdesign.com',
    cta_label: 'Solicită platforma sănătate',
    bullets: [
      'Sisteme gaze medicale (O2, N2O, CO2, aer)',
      'Săli operație ISO 5/7/8 cleanroom',
      'Laboratoare BSL-2 / BSL-3 biosafety',
      'Sisteme HEPA filtration + tracking',
      'DSP autorizare sanitară completă',
    ],
  },
  {
    slug: 'sport-stadioane',
    title_ro: 'Sport & Stadioane — Documentație EPD',
    title_en: 'Sport & Stadiums — EPD documentation',
    h1: 'Stadioane, sport arenas, baze sportive',
    icon: '🏟️',
    accent: 'green',
    eyebrow: 'Sports infrastructure',
    intro: 'Documentație tehnică stadioane FIFA/UEFA, săli polivalente, piste atletism, bazine olimpice, gazon hibrid, sisteme iluminat IFA conform.',
    metrics: [
      { v: 'FIFA/UEFA', l: 'Standards' }, { v: 'LED IFA', l: 'Lighting' },
      { v: 'Hibrid', l: 'Gazon' }, { v: 'ADA', l: 'Accesibilitate' },
    ],
    keywords: 'stadion romania, FIFA UEFA standards, sala polivalenta, bazin olimpic, gazon hibrid stadion, iluminat IFA stadion, ADA accesibilitate, infrastructura sportiva',
    cta_email: 'sport@energyprojectdesign.com',
    cta_label: 'Solicită demo stadioane',
    bullets: [
      'Stadioane FIFA/UEFA category 1-4',
      'Iluminat IFA + LED 4K broadcast',
      'Gazon hibrid (natural + sintetic)',
      'Bazine olimpice FINA standard',
      'Săli polivalente multifuncționale',
    ],
  },
];

export function findIndustry(slug) {
  return INDUSTRY_PAGES.find((p) => p.slug === slug);
}
